import { BaseOption } from '@/hooks/useTypeToOptions';
import { useGetOfficeMembersHook } from 'ap-openapi';
import { useCallback } from 'react';

export const useOfficeMemberOptions = () => {
  const getOfficeMembersApi = useGetOfficeMembersHook();

  const fetchOfficeMembers = useCallback(
    async (memberIds: string[]): Promise<BaseOption[]> => {
      if (memberIds.length === 0) return [];

      try {
        // Filter by the selected ids and ask for that many rows. OfficeMember
        // pages an unfiltered list; this lookup does not. Kaminari has no
        // max_per_page, and the next link drops office_member_ids.
        const response = await getOfficeMembersApi({
          office_member_ids: memberIds,
          per: memberIds.length.toString(),
        });

        return (response.data.office_members ?? []).map((member) => ({
          label: member.name ?? '',
          value: member.id ?? '',
        }));
      } catch {
        return [];
      }
    },
    [getOfficeMembersApi]
  );

  return { fetchOfficeMembers };
};
